class HtmlHelpers {
  static getProductCardHTML({ product = {}, finishData = {}, customerEmail } = {}) {
    // Load ProductCardTemplate if not already loaded
    if (typeof ProductCardTemplate === 'undefined') {
      console.warn('ProductCardTemplate not loaded, returning fallback HTML');
      return this.getFallbackHTML(product);
    }
    
    return ProductCardTemplate.renderCard({
      product: product,
      finishData: finishData,
      customerEmail: customerEmail,
      collectionHandle: null,
      isSearchResult: false
    });
  }
  
  static getFallbackHTML(product) {
    return `
      <li class="product type-product">
        <a href="/products/${product.handle}" class="woocommerce-LoopProduct-link woocommerce-loop-product__link">
          <h3 class="h2 woocommerce-loop-product__title">${product.title}</h3>
        </a>
      </li>
    `;
  }
}
